export type Lang = 'en' | 'ru';

export interface LangConfig {
  flag: string;   // emoji flag
  label: string;  // full name in native script
  code: string;   // 2-letter abbreviation shown on the button
}

/** Master registry — add new languages here only */
export const LANG_CONFIG: Record<Lang, LangConfig> = {
  en: { flag: '🇬🇧', label: 'English',  code: 'EN' },
  ru: { flag: '🇷🇺', label: 'Русский',  code: 'RU' },
};

/**
 * Parse a shop's menuLanguages array (e.g. ["en","ru"]) into valid Lang
 * codes.  Always includes 'en' as the baseline.
 */
export function resolveShopLangs(menuLanguages?: string[]): Lang[] {
  if (!menuLanguages?.length) return ['en'];
  const valid = menuLanguages.filter((l): l is Lang => l in LANG_CONFIG);
  return Array.from(new Set(['en' as Lang, ...valid]));
}

/**
 * Returns the translated value for a field on a DynamoDB record.
 * Falls back to the English field when no translation exists.
 *
 * @example getTranslated(product, 'productName', 'ru')
 */
export function getTranslated(obj: any, field: string, lang: Lang): string {
  if (!obj) return '';
  if (lang === 'en') return obj[field] ?? '';
  return obj?.translations?.[lang]?.[field] ?? obj[field] ?? '';
}
